import { OfflineReason, OfflineService } from 'app/services/offline.service';
import { empty, Observable } from 'rxjs';

import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { debounce } from 'lodash';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BackgroudSyncService {
  syncing: boolean;
  waitingToSyncAgain: boolean;
  private debouncedSyncRequest: any;

  constructor(private offline: OfflineService) {}

  /**
   * Ask the service to sync changes once it can
   */
  addSyncRequest(request: SyncCallback) {
    if (!this.debouncedSyncRequest) {
      this.debouncedSyncRequest = debounce(this.debounceSyncRequests.bind(this), 5000);
    }

    this.debouncedSyncRequest(request);
  }

  private debounceSyncRequests(request: SyncCallback) {
    // if we are either syncing, or uncapable of syncing right now,
    // then wait to sync…
    if (this.syncing || this.offline.isOffline()) {
      this.waitingToSyncAgain = true;
    } else {
      this.startSyncing(request);
    }
  }

  private handleError(err: any) {
    this.syncing = false;
    console.error(err);
    // force the user as offline due to bad network
    if (err instanceof HttpErrorResponse) {
      this.offline.forceOffline(true, OfflineReason.BAD_NETWORK);
    }

    return empty();
  }

  private startSyncing(request: SyncCallback) {
    this.waitingToSyncAgain = false;
    this.syncing = true;
    request()
      .pipe(catchError(this.handleError.bind(this)))
      .subscribe(
        () => {
          this.syncing = false;

          // if we need to sync immediately again, start another sync request…
          if (this.waitingToSyncAgain) {
            this.startSyncing(request);
          }
        },
      );
  }
}

type SyncCallback = () => Observable<void>;
